module.exports = __webpack_public_path__ + "static/fb-interns-c26704c255fbf39156f5a043ab024278.png";